import React, { useMemo } from 'react';
import { useLocalStorageState } from '@gogame/hooks-ts';

import { Typography, Link, Grid, makeStyles, Button } from '@gogame/components';

import { oktaInstances } from './oktaAuth';
import { useLogo } from 'components/hooks/useLogo';

const useStyles = makeStyles((theme) => ({
  root: {},
  logoBackground: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  logoContainer: {
    height: '120px',
  },
  logo: {
    width: '200px',
    height: '80px',
  },
}));

export const OktaSignInWidget = ({ onLogin }) => {
  const classes = useStyles();

  const [storageOktaProvider, setStorageOktaProvider] =
    useLocalStorageState('oktaProvider');

  const oktaProvider = useMemo(() => {
    if (!storageOktaProvider) {
      setStorageOktaProvider(process.env.REACT_APP_OKTA_DOMAIN);
      return process.env.REACT_APP_OKTA_DOMAIN;
    }
    return storageOktaProvider;
  }, [storageOktaProvider, setStorageOktaProvider]);

  const switchToOtherOktaProvider = useMemo(() => {
    if (oktaInstances.length === 2) {
      if (storageOktaProvider) {
        return oktaInstances?.find((item) => item.domain !== oktaProvider);
      }
      return oktaInstances.at(-1);
    }
    return null;
  }, []);

  const handleSwitchToOtherOktaProvider = () => {
    if (switchToOtherOktaProvider) {
      setStorageOktaProvider(switchToOtherOktaProvider?.domain);
      window.location.reload();
    }
  };

  const { authLogoUrl } = useLogo();

  return (
    <div>
      {switchToOtherOktaProvider ? (
        <div
          style={{
            display: 'flex',
            position: 'fixed',
            top: '8px',
            right: '8px',
          }}
        >
          <Link onClick={handleSwitchToOtherOktaProvider}>
            <Typography variant={'caption'}>
              Switch to {switchToOtherOktaProvider?.name}
            </Typography>
          </Link>
        </div>
      ) : null}
      <Grid
        item
        container
        direction={'column'}
        alignContent={'center'}
        justifyContent={'center'}
        className={classes.logoContainer}
      >
        <Grid item>
          <svg className={classes.logo}>
            <use href={authLogoUrl + '#logo'}></use>
          </svg>
        </Grid>
      </Grid>
      <Grid
        item
        container
        direction={'column'}
        alignContent={'center'}
        justifyContent={'center'}
      >
        <Grid item>
          <Button variant={'contained'} size={'large'} onClick={onLogin}>
            Login with okta
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
